import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '@gbs-monorepo-packages/auth';

export const useTermsGuard = (): void => {
  const { user, latestTermsVersion, termsAcceptancePath, termsExemptPaths } =
    useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !termsAcceptancePath) return;
    if (termsExemptPaths.includes(pathname)) return;
    if ((user.currentTermsVersionAccepted ?? 0) < latestTermsVersion) {
      navigate(termsAcceptancePath, {
        replace: true,
        state: { from: pathname },
      });
    }
  }, [
    user,
    latestTermsVersion,
    pathname,
    termsAcceptancePath,
    termsExemptPaths,
    navigate,
  ]);
};
